// 测试环境模板的数据地址 https://test.allflow.cn/4ebb17ef-d747-471d-9c28-4363d4522749
// 下面是表头对应的字段。
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

export const useTemplateConsts = () => {
  const { t } = useAppTranslation();
  return {
    TEMPLATE_CATEGORY: t('hooks.template.template_category'),
    ONE_STAGE_CATEGORY: t('hooks.template.one_stage_category'),
    TWO_STAGE_CATEGORY: t('hooks.template.two_stage_category'),
    THREE_STAGE_CATEGORY: t('hooks.template.three_stage_category'),
    TEMPLATE_HOME_PAGE_TOP: t('hooks.template.home_page_top'),
    TEMPLATE_NAME: t('hooks.template.template_name'),
    TEMPLATE_LINK: t('hooks.template.template_link'),
    TEMPLATE_SOURCE: t('hooks.template.template_source'),
    TEMPLATE_SOURCE_IMAGE: t('hooks.template.source_image'),
    TEMPLATE_IMAGE: t('hooks.template.template_image'),
    TEMPLATE_RELEASE: t('common.publish'),
    TEMPLATE_DESC: t('hooks.template.template_desc'),
    TEMPLATE_URL: t('hooks.template.template_url'),
    TEMPLATE_RECOMMEND_TAG: t('hooks.template.recommend_tag'),
    TEMPLATE_EMPTY_RECOMMEND_TAG: t('hooks.template.empty_recommend_tag'),
  };
};

// Legacy exports for backward compatibility
export const TEMPLATE_CATEGORY = 'hooks.template.template_category';
export const ONE_STAGE_CATEGORY = 'hooks.template.one_stage_category';
export const TWO_STAGE_CATEGORY = 'hooks.template.two_stage_category';
export const THREE_STAGE_CATEGORY = 'hooks.template.three_stage_category';
export const TEMPLATE_HOME_PAGE_TOP = 'hooks.template.home_page_top';
export const TEMPLATE_NAME = 'hooks.template.template_name';
export const TEMPLATE_LINK = 'hooks.template.template_link';
export const TEMPLATE_SOURCE = 'hooks.template.template_source';
export const TEMPLATE_SOURCE_IMAGE = 'hooks.template.source_image';
export const TEMPLATE_IMAGE = 'hooks.template.template_image';
export const TEMPLATE_RELEASE = 'common.publish';
export const TEMPLATE_DESC = 'hooks.template.template_desc';
export const TEMPLATE_URL = 'hooks.template.template_url';
export const TEMPLATE_RECOMMEND_TAG = 'hooks.template.recommend_tag';
export const TEMPLATE_EMPTY_RECOMMEND_TAG = 'hooks.template.empty_recommend_tag';
